import { Injectable, inject, signal } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from './auth.service';

@Injectable({ providedIn: 'root' })
export class AuthPromptService {
  private readonly authService = inject(AuthService);
  private readonly router = inject(Router);

  /** Legacy flag — auth UI is the /login page, not a modal. */
  readonly visible = signal(false);
  private readonly returnUrl = signal<string | null>(null);

  /**
   * Returns true if signed in; otherwise routes to /login
   * and remembers where to send the user after success.
   */
  requestAuth(returnUrl?: string): boolean {
    if (this.authService.currentUser()) {
      return true;
    }

    const target = returnUrl ?? this.router.url;
    this.storeReturnUrl(target);
    this.visible.set(false);

    const onAuthPage = this.router.url.split(/[?#]/)[0] === '/login' || this.router.url.split(/[?#]/)[0] === '/register';
    if (!onAuthPage) {
      void this.router.navigate(['/login'], {
        queryParams:
          target && target !== '/login' && target !== '/register' ? { returnUrl: target } : undefined
      });
    }
    return false;
  }

  storeReturnUrl(url: string | null | undefined): void {
    if (!url || url === '/login' || url === '/register') return;
    this.returnUrl.set(url);
  }

  onAuthSuccess(): void {
    const target = this.returnUrl();
    this.returnUrl.set(null);
    this.visible.set(false);
    if (target) {
      void this.router.navigateByUrl(target);
    } else {
      void this.router.navigateByUrl('/home');
    }
  }

  close(): void {
    this.visible.set(false);
  }

  clearReturnUrl(): void {
    this.returnUrl.set(null);
  }
}
